import "../styles/default.scss";

import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import ContentSection from "../../../common/ContentSection";
import OtherNotificationsSettings from "../../OtherNotificationsSettings";

const NotificationsSettings = ({ translate }) => (
  <div className="notifications-settings">
    <ContentSection>
      <h1>{translate("Notifications")}</h1>
      <p>{translate("Here you can manage your notifications")}</p>
    </ContentSection>
    <ContentSection>
      <OtherNotificationsSettings />
    </ContentSection>
  </div>
);

NotificationsSettings.propTypes = {};

export default withTranslations(NotificationsSettings);
